import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    dayOffWeek: () => {
        return HTTP.get('/holiday/week', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editDayOffWeek: (id, status) => {
        return HTTP.post('/holiday/week/update', {
            id: id,
            status: status
        }, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    holidayList: () => {
        return HTTP.get('/holiday/special', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addHoliday: (data) => {
        return HTTP.post('/holiday/special/create',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editHoliday: (id,data) => {
        return HTTP.post('/holiday/special/update/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    detailHoliday: (id) => {
        return HTTP.get('/holiday/special/edit/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    deleteHoliday: (id) => {
        return HTTP.post('/holiday/special/delete/'+id,null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}
